import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  icon_size_nano: {
    fontSize: 10,
  },
  icon_size_micro: {
    fontSize: 12,
  },
  icon_size_extraSmall: {
    fontSize: 14,
    verticalAlign: 'text-top',
  },
  icon_size_small: {
    fontSize: 16,
  },
  icon_size_default: {
    fontSize: 20,
  },
  icon_size_normal: {
    fontSize: 24,
  },
  icon_size_large: {
    fontSize: 40,
  },
  icon_color_primary: {
    color: theme.tokens.colors.original.brand.primary,
  },
  icon_color_inherit: {
    color: 'inherit',
  },
  icon_color_disabled: {
    color: theme.tokens.colors.stroke.secondary,
  },
  icon_color_secondary: {
    color: theme.tokens.colors.text.light.tertirary,
  },
  icon_color_success: {
    color: theme.tokens.colors.accent.text.success,
  },
  icon_color_warning: {
    color: theme.tokens.colors.accent.text.warning,
  },
  icon_color_review: {
    color: theme.tokens.colors.accent.text.review,
  },
  icon_color_error: {
    color: theme.tokens.colors.accent.text.error,
  },
  icon_color_textPrimary: {
    color: theme.tokens.colors.text.light.primary,
  },
  icon_color_violet: {
    color: theme.tokens.colors.accent.text.violet,
  },
  icon_color_blue: {
    color: theme.tokens.colors.accent.text.blue,
  },
  icon_color_white: {
    color: theme.tokens.colors.bg.light.primary,
  },
  icon_color_action: {
    color: theme.palette.common.black,
  },
}));
